import { QueryClient } from '@tanstack/react-query';
import type { PortalType } from '@shared/types/database';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
    mutations: {
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});

// Query Keys factory for consistent cache key management
export const queryKeys = {
  all: ['jurisprudentie'] as const,
  lists: () => [...queryKeys.all, 'list'] as const,
  list: (filters: Record<string, any>) => [...queryKeys.lists(), filters] as const,
  details: () => [...queryKeys.all, 'detail'] as const,
  detail: (id: string) => [...queryKeys.details(), id] as const,
  recent: (page: number, portalIds?: PortalType[]) => [...queryKeys.lists(), 'recent', { page, portalIds }] as const,
  search: (params: Record<string, any>) => [...queryKeys.lists(), 'search', params] as const,
  // Filter counts for SearchFilters component
  filters: {
    all: ['filters'] as const,
    counts: (params: Record<string, any>) => [...queryKeys.filters.all, 'counts', params] as const,
  },
};